import { useEffect, useState } from "react";
import logo from "../assets/image/rccglogo.webp";
import ig from "../assets/image/ig.webp";
import fb from "../assets/image/fb.webp";
import yt from "../assets/image/yt.webp";
import x from "../assets/image/x.webp";
import "../css/style.css";
import "../css/mobile.css";
import { toast } from "react-toastify";

export default function Footer() {
  const [socialLinks, setSocialLinks] = useState({
    instagram: "/",
    facebook: "/",
    youtube: "/",
    twitter: "/",
  });
  const [submitting, setSubmitting] = useState(false);
  const TEST_BASE_URL = process.env.REACT_APP_BASE_URL;

  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const response = await fetch(`${TEST_BASE_URL}/social-links`, {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        });

        if (!response.ok) {
          const errorData = await response.text();
          console.error("API Error:", errorData);
          throw new Error(`Failed to fetch social links: ${response.status}`);
        }

        const data = await response.json();

        const socialData = data.data || {};

        setSocialLinks({
          instagram: socialData.instagram_link || "/",
          facebook: socialData.facebook_link || "/",
          youtube: socialData.youtube_link || "/",
          twitter: socialData.x_link || "/",
        });
      } catch (error) {
        console.error("Error fetching social links:", error);
      }
    };

    fetchSocialLinks();
  }, [TEST_BASE_URL]);

  return (
    <footer className="footer">
      <div className="container">
        <div className="row footer-row">
          <div className="col-md-6 col-12">
            <a
              href="https://www.rccgbournemouth.org"
              className="footer-logo text-white"
            >
              <img src={logo} alt="RCCG Logo" />
              <span className="text-white">
                The Redeemed Christian <br />
                Church of God, <br />
                New Beginning Chapel.
              </span>
            </a>
            <div className="footer-text">
              <div>
                <h6>Contact</h6>
                <a href="tel:07448583833" className="text-white">
                  <span className="text-white">
                    <small>07448583833</small>
                  </span>
                </a>
                <br />
                <a
                  href="mailto:info@rccgbournemouth.org"
                  className="text-white"
                >
                  <span className="text-white">
                    <small>info@rccgbournemouth.org</small>
                  </span>
                </a>
                <div className="socials">
                  <a
                    href={socialLinks.instagram}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={ig} alt="Instagram" />
                  </a>
                  <a
                    href={socialLinks.facebook}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={fb} alt="Facebook" />
                  </a>
                  <a
                    href={socialLinks.youtube}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={yt} alt="YouTube" />
                  </a>
                  <a
                    href={socialLinks.twitter}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <img src={x} alt="X (Twitter)" />
                  </a>
                </div>
              </div>
              <div className="location">
                <h6>Location</h6>
                <span>
                  <small>
                    <a
                      href="https://maps.app.goo.gl/oTewkvkvw5acZB6EA"
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      Praise Arena, Wootton <br /> Gardens Bournemouth <br />{" "}
                      BH1 1PW
                    </a>
                  </small>
                </span>
              </div>
            </div>
          </div>
          <div className="col-md-5 stay">
            <h5>Stay Connected</h5>
            <p className="pt-2 pb-4 text-white">
              <small>
                Sign up with your email address to receive updates from <br />
                RCCG Bournemouth
              </small>
            </p>
            <div className="subscribe-form">
              <form
                onSubmit={async (e) => {
                  e.preventDefault();

                  const emailInput = e.target.elements.email;
                  const email = emailInput.value.trim();

                  if (!email) {
                    toast.error("Please enter a valid email address");
                    return;
                  }

                  setSubmitting(true);

                  try {
                    const response = await fetch(
                      `${TEST_BASE_URL}/newsletter`,
                      {
                        method: "POST",
                        headers: {
                          Accept: "application/json",
                          "Content-Type": "application/json",
                        },
                        body: JSON.stringify({ email }),
                      }
                    );

                    const responseText = await response.text();
                    let data = null;

                    try {
                      data = JSON.parse(responseText);
                    } catch {
                      console.warn(
                        "Newsletter API returned non-JSON response:",
                        responseText
                      );
                    }

                    if (!response.ok) {
                      const errorMessage =
                        data?.message ||
                        data?.error ||
                        "Unable to subscribe. Please try again.";

                      toast.error(errorMessage);
                      return;
                    }

                    toast.success(
                      data?.message || "Subscribed successfully! Thank you."
                    );

                    emailInput.value = "";
                  } catch (error) {
                    toast.error("Network error. Please try again.");
                    console.error("Newsletter Error:", error);
                  } finally {
                    setSubmitting(false);
                  }
                }}
              >
                <input
                  type="email"
                  name="email"
                  placeholder="Enter your email address"
                  className="form-control footer-input"
                  required
                />

                <p className="pt-2 text-white">
                  <small>
                    Please read our
                    <a
                      href="https://www.rccgbournemouth.org/privacy-notice"
                      className="text-white"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      {" "}
                      <u>Privacy Notice</u>
                    </a>{" "}
                    to learn how we protect your personal data.
                  </small>
                </p>

                <button
                  className="btn btn-subscribe"
                  type="submit"
                  disabled={submitting}
                >
                  {submitting ? (
                    <span className="text-white"> Subscribing... </span>
                  ) : (
                    "Subscribe"
                  )}
                </button>
              </form>
            </div>
          </div>
          <div className="footer-links">
            <a href="https://www.rccgbournemouth.org/about-us">About Us</a>
            <a href="https://www.rccgbournemouth.org/resources">Resources</a>
            <a href="https://www.rccgbournemouth.org/ministry">Ministries</a>
            <a href="https://www.rccgbournemouth.org/events">Events</a>
            <a href="https://www.rccgbournemouth.org/contact-us">Contact</a>
            <a href="/login">RCCG New Beginning Chapel E-Portal</a>
          </div>
          <div className="footer-bottom">
            <a
              href="https://www.rccgbournemouth.org/privacy-notice"
              target="_blank"
              rel="noopener noreferrer"
            >
              <small>
                <u>Privacy Notice</u>
              </small>
            </a>
            <a href="https://www.rccgbournemouth.org/cookies">
              <small>
                <u>Cookie Notice</u>
              </small>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
